import React, { useState } from 'react';
import { quoteRemoveLiquidity,removeLiquidity } from '../../functions/dexfunctions'
import { popupManager } from '../common/PopupManager';
import { useParams } from "react-router-dom";

export default function RemoveLiquidity({reserve,tokenAddress,signer,dataToken,chain,transactionPath}) {
  const [ethAmount, setEthAmount] = useState('');
  const [tokenAmount, setTokenAmount] = useState([]);
  const [loadingQuote,setloadingQuote] = useState(false)
  const ethAddress = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";
  const symbolNative = "ETH";

  const [LPtokensOut,setLPtokensOut] = useState(0)
  const handleEthChange = (e) => {
    setloadingQuote(true)
    const value = e.target.value;
    setEthAmount(value)
    getLPout(value)


  };
  const getLPout = async (value) => {
    const LPout = await quoteRemoveLiquidity(ethAddress,tokenAddress,value,signer,chain)
    setTokenAmount(LPout)
    setloadingQuote(false)
  }
  function chainParamToChainId(chainParam) {
    switch (chainParam) {
      case "ethereum":
        return 1;
      
      // add more if needed
      default:
        return null; // or 1 as a default
    }
  }
  const removeLiquidityAttempt = async () => {
    let id = Date.now();
    try{
      if (!signer) {
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: "Please connect your wallet before buying tokens",
          duration: 6000,
        });
        return;
      }
      const network = await signer.provider.getNetwork();
      const chainId = Number(network.chainId);
      const requiredChainId = chainParamToChainId(chain);
      if (chainId !== requiredChainId) {
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: "Please connect your wallet to the selected network!",
          duration: 6000,
        });
        return;
      }
      popupManager.addPopup({
        id: id,
        type: "message",
        message: `Removing ${ethAmount} of ${symbolNative} and ${tokenAmount[1]} of Tokens from Liquidity`,
      });
     const resp = await removeLiquidity(ethAddress,tokenAddress,ethAmount,0,0,signer,ethAddress,chain)

     popupManager.removePopup(id);
     let successful_id = Date.now();

     popupManager.addPopup({
       id: successful_id,
       type: "success",
       message:
         "Transaction sent!",
     });
    }catch(e){
        console.log(e)
        popupManager.removePopup(id);
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: e.toString(),
        duration: 6000,
      });
    }
  }

  return (
    <form>
      <div className="mb-4 w-full">
        <label className="block text-start text-[13px] text-gray-300 font-[500] kanit-light mb-2" htmlFor="ethAmount">
            LP Tokens Amount
          </label>
          <input
            type="number"
            id="ethAmount"
            value={ethAmount}
            onWheel={e => e.target.blur()}  
            onChange={handleEthChange}
              min="0"
            placeholder="LP Token Amount"
            className="w-full p-2 py-4 text-[13px] border border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none "
          />
      </div>
      <div>
          {tokenAmount[0] !== 0 && 
              <div className='border-t border-white/10 pt-3 mt-4 noto-sans-display text-[#7b7f8f] text-[13px] font-[400] mb-4'>
                {loadingQuote === true ? 
                         <div className='h-5 animate-pulse bg-white/5 '></div>
                 :
                 <div className='flex gap-1 justify-start mb-1'> 
                 <p>You send </p><p>{ethAmount ? ethAmount : 0} LP Tokens</p>
                 </div> 
                 }
                {loadingQuote === true ? 
                  <div className='h-5 animate-pulse bg-white/5'></div>
                :
                <div className='flex gap-1 justify-start '> 
                  <p>You will receive </p><p>{tokenAmount[1] ? Math.round(tokenAmount[1]*1000000)/1000000 : 0} {symbolNative}</p>
                </div> 
                }
                {loadingQuote === true ? <div className='h-5 animate-pulse bg-white/5 '></div>
                  :
                  <div className='flex gap-1 justify-start'>
                    <p>You will receive</p> <p>{tokenAmount[2] ? Math.round(tokenAmount[2]*1000)/1000 : 0} {dataToken.symbol}</p>
                  </div> 
                } 
              </div>
          }
      </div>

      {ethAmount <= LPtokensOut ? 
      <button
          disabled
          type="button"
          className="w-full text-[16px] font-[600] text-red-400 bg-red-400/10 border border-red-400 opacity-60 cursor-not-allowed py-2 px-4 rounded-xl focus:outline-none mb-2 transition duration-300"
          >
          Not enough LP Tokens
      </button>:
      <button
          onClick={removeLiquidityAttempt}
            type="button"
            className="w-full text-[16px] font-[600] text-red-400 bg-red-400/10 border border-red-400 hover:bg-red-500/20 hover:border-red-500 transition duration-300 py-2 px-4 rounded-xl focus:outline-none mb-2"
          >
            Remove 
      </button>
      }

      {/* Transaction Path Indicator */}
      {signer && transactionPath && (
        <div className="mt-4 mb-2 p-3 bg-white/5 border border-white/10 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <svg className="w-4 h-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-white/80 text-sm font-medium">Transaction Path</span>
          </div>
          <div className="space-y-1">
            {transactionPath.map((step, index) => (
              <div key={index} className="flex items-center gap-2 text-white/70 text-xs">
                <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                <span>{step}</span>
              </div>
            ))}
          </div>
        </div>
      )}

    </form>
  );
}
